import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {TransactionService} from '../../services/transaction.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-transaction-notes-manager',
  templateUrl: './transaction-notes-manager.component.html',
  styleUrls: ['./transaction-notes-manager.component.scss']
})
export class TransactionNotesManagerComponent implements OnInit {

    transactionNotes = []

    addnotes = {
        add_notes: '',
    }
  	constructor(
      public activeModal: NgbActiveModal, 
      private modelService: NgbModal,
      private transaction: TransactionService,
      ) {
        

    }

	  ngOnInit() {
      this.getAllNotes();
  	}

    
  	closeClick() {
        // if (this.isUpdated) {
        //     this.activeModal.close({ case: 'remove_finding_image' })
        // } else {
            this.activeModal.close('Close click')
        // }
    }

    getAllNotes(){
      this.transaction.notesList()
      .subscribe(
          data=>{
            this.transactionNotes = data;
          }
      );
    }

    deleteNote(noteId) {
      Swal({
        title: 'Are you sure?',
        text: 'Delete!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it'
      }).then((result) => {
        if (result.value) {
          this.transaction.deleteNote(noteId).subscribe(
            data => {
                  this.getAllNotes();
                  Swal(
                    'Deleted!',
                    'Deleted.',
                    'success'
                  )
            } 
           );
          
          } else if (result.dismiss === Swal.DismissReason.cancel) {
         
        }
      })
  }
  addNote() {
    if(this.addnotes.add_notes){
      this.transaction.addNote(this.addnotes).subscribe(
        data => {
            Swal({
                title: 'Success',
                text: 'Added successfully'
            })
            this.addnotes.add_notes = ''
            this.getAllNotes();
        }
      );
    }
  }

}
